import { render, staticRenderFns } from "./CategorySlider.vue?vue&type=template&id=2ab1c022&scoped=true"
import script from "./CategorySlider.vue?vue&type=script&lang=js"
export * from "./CategorySlider.vue?vue&type=script&lang=js"
import style0 from "./CategorySlider.vue?vue&type=style&index=0&id=2ab1c022&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab1c022",
  null
  
)

export default component.exports